import { render, staticRenderFns } from "./CoreUploadV2.vue?vue&type=template&id=2d55f8ae&"
import script from "./CoreUploadV2.vue?vue&type=script&lang=js&"
export * from "./CoreUploadV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports